export const lotRoute = (lotId = ':lotId') => `/lot/${lotId}/book`

export const lotFeatureQueryParam = 'feature'

export const lotRouteShortDuration = (lotId = ':lotId') => `${lotRoute(lotId)}?${lotFeatureQueryParam}=short`
export const lotRouteLongDuration = (lotId = ':lotId') => `${lotRoute(lotId)}?${lotFeatureQueryParam}=long`
export const lotRouteNightDuration = (lotId = ':lotId') => `${lotRoute(lotId)}?${lotFeatureQueryParam}=night`
export const lotRouteSubscriptions = (lotId = ':lotId') => `${lotRoute(lotId)}?${lotFeatureQueryParam}=subscription`
export const lotRouteNotFound = () => `/lot-not-found`
export const lotRouteNotAvailable = (lotId = ':lotId') => `${lotRoute(lotId)}/not-available`
export const lotBaseRoute = (lotId = ':lotId') => `/lot/${lotId}`
